import type { FilterSchema, FilterOperation } from './simpleFilters'
interface FilterQueryItem {
  name: string
  target?: string
  operation: FilterOperation
  values: any | any[]
}

export function useQueryFilters(parsedSchema: Record<string, FilterSchema>) {
  const route = useRoute()
  const exclude = ['sort', 'page', 'limit']

  const queries = computed(() =>
    Object.entries(route.query).reduce((acc, [routeName, routeValue]) => {
      const [name, operation]: any[] = routeName.split(/[[\]]{1,2}/)
      const values = Array.isArray(routeValue)
        ? routeValue[0]?.split(',')
        : routeValue?.split(',')

      if (values?.some(Boolean) && !exclude.includes(name)) {
        acc.push({
          name,
          operation,
          values,
        })
      }

      return acc
    }, [] as FilterQueryItem[]),
  )

  const queryState = computed(() =>
    queries.value
      .map((qf) => {
        const filter = parsedSchema[qf.name]
        let value =
          filter && filter.mode === 'single' ? qf.values.at(0) : qf.values
        if (value === 'true') value = true
        if (value === 'false') value = false
        return {
          name: qf.name,
          value,
        }
      })
      .reduce((acc, v) => ({ ...acc, [v.name]: v.value }), {}),
  )

  return { queries, queryState }
}
